<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { setStore, getStore, removeStore } from '@/utils/storage'
import { userInfoDetail } from "@/api/index";
export default {
  name: 'App',
  created(){
    let userInfo = getStore("userInfo");
    let TokenData = getStore("TokenData");
    if (userInfo && TokenData && TokenData != 'null') {
      this.$store.commit('RECORD_TOKENINFO', JSON.parse(TokenData))
      this.$store.commit('RECORD_USERINFO', JSON.parse(userInfo))
      userInfoDetail().then((res)=>{
      // userInfoDetail({id: (JSON.parse(userInfo)).Id},true).then((res)=>{
        if (res.Code === 200) {
          this.$store.commit('RECORD_TOKENINFO', JSON.parse(TokenData))
          this.$store.commit('RECORD_USERINFO', res.Data.Entity)
          this.$store.commit('SET_PreOrderCount',res.Data.PreOrderCount)
        } else {
          removeStore("userInfo");
          removeStore("TokenData");
          this.$store.commit('RECORD_TOKENINFO', null)
          this.$store.commit('RECORD_USERINFO', null)
        }
      }).catch(err => {
        console.log(err);
        // removeStore("userInfo");
        // removeStore("TokenData");
        // this.$store.commit('RECORD_TOKENINFO', null)
        // this.$store.commit('RECORD_USERINFO', null)
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";
  @import "assets/style/common.scss";
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue